import { render } from "./OilCompData.vue?vue&type=template&id=42c2b288"
import script from "./OilCompData.vue?vue&type=script&lang=js"
export * from "./OilCompData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__